import axios from '../axios-instance';

const PREFIX = '/general-trade';

export const getContacts = () => axios.$get(`${PREFIX}/contacts`, { params: { type: 'b2b-seller-contact' } });
